export enum ArchiveFilter {
  ACTIVE = "active",
  ARCHIVED = "archived",
  BOTH = "both"
}
